module.exports = __webpack_public_path__ + "static/img/MP.b8c7d0eb.png";